"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedResponseToJSON = exports.PaginatedResponseFromJSONTyped = exports.PaginatedResponseFromJSON = void 0;
var _1 = require("./");
function PaginatedResponseFromJSON(json) {
    return PaginatedResponseFromJSONTyped(json, false);
}
exports.PaginatedResponseFromJSON = PaginatedResponseFromJSON;
function PaginatedResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paginationInfo': (0, _1.PaginationInfoFromJSON)(json['paginationInfo']),
    };
}
exports.PaginatedResponseFromJSONTyped = PaginatedResponseFromJSONTyped;
function PaginatedResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paginationInfo': (0, _1.PaginationInfoToJSON)(value.paginationInfo),
    };
}
exports.PaginatedResponseToJSON = PaginatedResponseToJSON;
